export const ROUTES_NAVIGATION_CONTEXT_KEY = 'routes_navigation_context';

export const buildRoutesReturnPath = (dateKey = '') => {
  const normalizedDateKey = String(dateKey || '').trim();
  if (!normalizedDateKey) return '/routes';
  return `/routes?${new URLSearchParams({ date: normalizedDateKey }).toString()}`;
};

export const readRoutesReturnDate = (search = '') => {
  try {
    return new URLSearchParams(search || '').get('date') || '';
  } catch {
    return '';
  }
};

export const prepareRoutesReturnHistory = (dateKey = '') => {
  if (typeof window === 'undefined' || !window.history) return;

  try {
    const returnPath = buildRoutesReturnPath(dateKey);
    const returnUrl = new URL(window.location.href);
    returnUrl.hash = `#${returnPath}`;
    const nextState = { ...(window.history.state || {}) };
    delete nextState.__modalBackId;

    window.history.replaceState(
      { ...nextState, codexBackTarget: returnPath },
      '',
      returnUrl.toString()
    );
  } catch {
    // no-op
  }
};

export const resolveRoutesExpandedDate = ({
  knownKeys = [],
  expandedDates = {},
  savedDateKey = '',
  savedDateApplied = false
} = {}) => {
  const preferredKey = (
    !savedDateApplied
    && savedDateKey
    && knownKeys.includes(savedDateKey)
  ) ? savedDateKey : null;

  return {
    activeKey: preferredKey
      || knownKeys.find((key) => expandedDates[key])
      || (savedDateKey && knownKeys.includes(savedDateKey) ? savedDateKey : null)
      || knownKeys[0]
      || null,
    savedDateApplied: savedDateApplied || Boolean(preferredKey)
  };
};

export const saveRoutesNavigationContext = (context) => {
  try {
    sessionStorage.setItem(ROUTES_NAVIGATION_CONTEXT_KEY, JSON.stringify(context || {}));
  } catch {
    // no-op
  }
};

export const readRoutesNavigationContext = () => {
  try {
    const raw = sessionStorage.getItem(ROUTES_NAVIGATION_CONTEXT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const clearRoutesNavigationContext = () => {
  try {
    sessionStorage.removeItem(ROUTES_NAVIGATION_CONTEXT_KEY);
  } catch {
    // no-op
  }
};
